import type { IMarketDataType } from '@ping/websockets';
import { parsePair } from '@ping/helpers';

/**
 * It takes a market array and add favorites and keywords array and returns a new market array with the custom props
 * array mapped to the market array
 * @param {IMarketDataType[]} market - IMarketDataType[]
 * @param {string[]} favData - string[] = []
 */

export const generateMarketPairsData = (market: IMarketDataType[], favData: string[] | readonly string[] = []) => {
  return market.map((marketPair: IMarketModified) => {
    const newMarketPair = { ...marketPair };
    const { base, quote, market } = parsePair.byInstrument(marketPair.instrument);
    newMarketPair.market = market;
    newMarketPair.favorites = favData.includes(market);
    newMarketPair.keywords = [`${base}${quote}`, `${quote}${base}`];
    newMarketPair.change = newMarketPair.close - newMarketPair.open;
    newMarketPair.changePercent = newMarketPair.open !== 0 ? (newMarketPair.change / newMarketPair.open) * 100 : 0;
    return newMarketPair;
  });
};
